import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { BundleInterface } from '../../store/mine_craft/bundlesSlice';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.bundlePath(value.id),
    push_cert_url: minecraftUrls.remoteUrl(value.push_cert_url),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
  };
}

export const bundlesEntity = new schema.Entity(
  'bundles',
  {},
  {
    processStrategy
  }
);

export const bundleEntity = new schema.Entity(
  'bundle',
  {},
  {
    processStrategy
  }
);

const fetchBundlesCollection = async (url: string, params: object = {}) => {
  const response    = await mineCraftApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      bundles: { [key: string]: BundleInterface };
    }
  >(response.data.bundles, [bundlesEntity]);

  return {
    bundles: normalized.entities?.bundles || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      bundle: BundleInterface;
    }
  >(response.data.bundle, bundleEntity);
  return normalized.entities;
}

export const fetchBundles = createAsyncThunk(
  'bundles/fetchBundles',
  async (params: object = {}) => fetchBundlesCollection('/onesky/bundles', params)
);

export const fetchBundle = createAsyncThunk(
  'bundles/fetchBundle',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/bundles/${id}`);
    return normalizeInstance(response);
  }
);

export const updateBundle = createAsyncThunk(
  'bundles/updateBundle',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/bundles/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyBundle = createAsyncThunk(
  'bundles/destroyBundle',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/bundles/${id}`);
    return response.data;
  }
);
